<template>
  <b-modal centered ref="checkin-modal" id="checkInModal" title="Check-In" hide-footer>
    <div v-if="loading" class="spinner-container">
      <spinner-loader />
    </div>

    <b-form v-if="!guest || !guest.customer_id">
      <p>A pre-authorized hold for the following amount</p>
      <div class="hold-amount-input">
        <currency-input name="Amount" :amount.sync="amount" :fieldState="stateAmount"/>
      </div>
      <p class="mt-3">will be placed on the the following credit card</p>

      <b-row class="mx-0 px-3 pr-4">
        <b-col xs="12" sm="3" class="pr-0 pt-1 card-label">Card Number</b-col>
        <b-col xs="12" sm="9">
          <b-form-input
            id="input-card-number"
            type="number"
            v-model="cardForm.card_number"
            placeholder=""
            :state="stateCardNumber"
            @keydown="(e) => onCheckMaxLength(e, cardForm.card_number, 16)"
          />
        </b-col>
      </b-row>

      <b-row class="mt-sm-3 mx-0 px-3 pr-4">
        <b-col xs="12" sm="3" class="card-label">Exp Month</b-col>
        <b-col xs="12" sm="3" class="pt-1">
          <b-form-input
            id="input-card-month"
            type="number"
            v-model="cardForm.card_exp_month"
            placeholder=""
            :state="stateCardExpMonth"
            @keydown="(e) => onCheckMaxLength(e, cardForm.card_exp_month, 2)"
          />
        </b-col>

        <b-col xs="12" sm="3" class="card-label">Exp Year</b-col>
        <b-col xs="12" sm="3" class="pt-1">
          <b-form-input
            id="input-card-year"
            type="number"
            v-model="cardForm.card_exp_year"
            placeholder=""
            :state="stateCardExpYear"
            @keydown="(e) => onCheckMaxLength(e, cardForm.card_exp_year, 2)"
          />
        </b-col>
      </b-row>

      <p class="mt-3">The hold will be removed 24 hours after check-out</p>
    </b-form>

    <b-form v-else>
      <p>A pre-authorized hold for the following amount</p>
      <div class="hold-amount-input">
        <currency-input name="Amount" :amount.sync="amount" :fieldState="stateAmount"/>
      </div>
      <p class="mt-3">will be placed on the following credit card</p>

      <p class="card-number h5 font-weight-bold">
        {{ spacedCardNumber(customerCard) }}
      </p>

      <p class="mt-3">The hold will be removed 24 hours after check-out</p>

      <b-collapse id="collapse-card-details" class="mt-2" :visible="isAddCard">
        <b-card>
          <b-form>
            <b-row class="mx-0">
              <b-col xs="12" sm="3" class="pr-0 pt-1 card-label">Card Number</b-col>
              <b-col xs="12" sm="9">
                <b-form-input
                  id="input-card-number"
                  type="number"
                  v-model="cardForm.card_number"
                  placeholder=""
                  :state="stateCardNumber"
                  @keydown="(e) => onCheckMaxLength(e, cardForm.card_number, 16)"
                />
              </b-col>
            </b-row>

            <b-row class="mt-sm-3 mx-0">
              <b-col xs="12" sm="3" class="card-label">Exp Month</b-col>
              <b-col xs="12" sm="3" class="pt-1">
                <b-form-input
                  id="input-card-month"
                  type="number"
                  v-model="cardForm.card_exp_month"
                  placeholder=""
                  :state="stateCardExpMonth"
                  @keydown="(e) => onCheckMaxLength(e, cardForm.card_exp_month, 2)"
                />
              </b-col>

              <b-col xs="12" sm="3" class="card-label">Exp Year</b-col>
              <b-col xs="12" sm="3" class="pt-1">
                <b-form-input
                  id="input-card-year"
                  type="number"
                  v-model="cardForm.card_exp_year"
                  placeholder=""
                  :state="stateCardExpYear"
                  @keydown="(e) => onCheckMaxLength(e, cardForm.card_exp_year, 2)"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-collapse>
    </b-form>

    <b-row class="mx-0 mt-2">
      <b-col xs="4" class="px-2">
        <b-button class="my-2 px-0 w-100" variant="danger" @click="onClickCancel">
          Skip & Check-In
        </b-button>
      </b-col>
      <b-col xs="4" class="px-2">
        <b-button class="my-2 w-100" variant="primary" @click="isAddCard = !isAddCard" v-if="guest && guest.customer_id">
          New Card
        </b-button>
      </b-col>
      <b-col xs="4" class="px-2">
        <b-button class="my-2 w-100" variant="success" @click="onClickCheckIn">
          Check-In
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import AlertMixin from '@/mixins/alert-mixin'
import CurrencyInput from "@/components/widgets/CurrencyInput";
import SpinnerLoader from "@/components/widgets/SpinnerLoader";

export default {
  name: "CheckInModal",
  components: {
    CurrencyInput,
    SpinnerLoader
  },
  mixins: [ AlertMixin ],

  data() {
    return {
      amount: 0,
      cardForm: {
        card_number: '',
        card_exp_month: '',
        card_exp_year: ''
      },
      customer: null,
      guest: null,
      isAddCard: false,
      triggered: false,
      loading: false,
      tabId: 0,
      bookingId: 0
    }
  },

  computed: {
    customerCard() {
      if (
        !this.customer ||
        !this.customer.sources ||
        !this.customer.sources.data ||
        !this.customer.sources.data.length
      ) {
        return '';
      }

      return this.customer.sources.data[0].last4;
    },

    stateAmount() {
      if (!this.triggered) {
        return null;
      }
      return !!this.amount;
    },

    stateCardNumber() {
      if (!this.isAddCard || !this.triggered) {
        return null;
      }

      return (
        !!this.cardForm.card_number &&
        this.cardForm.card_number.toString().length === 16
      );
    },

    stateCardExpMonth() {
      if (!this.isAddCard || !this.triggered) {
        return null;
      }
      return (
        !!this.cardForm.card_exp_month
        && this.cardForm.card_exp_month .toString().length <= 2
      );
    },

    stateCardExpYear() {
      if (!this.isAddCard || !this.triggered) {
        return null;
      }
      return (
        !!this.cardForm.card_exp_year &&
        this.cardForm.card_exp_year.toString().length <= 2
      );
    }
  },

  methods: {
    ...mapActions([
      'addCustomerForGuest',
      'addStripeCardHold',
      'addTabCardHold',
      'getContacts',
      'getStripeCustomer'
    ]),

    init() {
      this.amount = 0;
      this.triggered = false;
      this.isAddCard = false;
      this.guest = null;
      this.customer = null;
      this.loading = false;
      this.tabId = 0;
      this.bookingId = 0;

      this.cardForm = {
        card_number: '',
        card_exp_month: '',
        card_exp_year: ''
      };
    },

    show(guest = {}, tab = {}) {
      this.init();
      this.guest = guest;
      this.tabId = tab.id;
      this.bookingId = tab.booking_id;

      this.$refs['checkin-modal'].show();

      if (!guest.customer_id) {
        this.isAddCard = true;
        return;
      }

      this.loading = true;

      this.getStripeCustomer(guest.customer_id)
        .then(res => {
          this.customer = res;
        })
        .catch(err => {
          this.errorNotification(`Failed to get customer info: ${ err }`)
        })
        .finally(() => {
          this.loading = false;
        })
    },

    hide() {
      this.$refs['checkin-modal'].hide();
    },

    checkIn() {
      if (!this.customer || !this.customer.id) {
        this.showMessage('Invalid card!', 'error');
        return;
      }

      let params = {
        customer: this.customer.id,
        amount: this.amount * 100,
        currency: 'usd',
        description: `Card Hold for Check In`,
        metadata: {
          booking_id: this.bookingId
        }
      }

      this.loading = true;

      this.addStripeCardHold(params)
        .then(res => {
          this.successNotification(`card hold success: ${ this.amount }`);

          let params = {
            tab_id: this.tabId,
            rate: this.amount,
            charge_id: res.id,
            description: `Card Hold for ${ this.guest.first_name } ${ this.guest.last_name }`
          };

          return this.addTabCardHold(params);
        })
        .then(res => {
          this.$emit('checkin');
        })
        .catch(err => {
          this.errorNotification(err)
        })
        .finally(() => {
          this.loading = false;
        })
    },

    onCheckMaxLength(e, v, n) {
      if (e.key == 'E' || e.key === 'e' || e.key === '+' || e.key === '-') {
        e.preventDefault();
        return;
      }

      if (e.keyCode >= 48 && e.keyCode <= 57) {
        if (v.length >= n) {
          e.preventDefault()
        }
      }
    },

    onClickCheckIn() {
      this.triggered = true;

      if (this.isAddCard) {
        if (
          !this.stateAmount ||
          !this.stateCardNumber ||
          !this.stateCardExpMonth ||
          !this.stateCardExpYear
        ) {
          return
        }

        const params = {
          ...this.cardForm,
          guest_id: this.guest.id
        }

        this.loading = true;

        this.addCustomerForGuest(params)
          .then(res => {
            this.customer = res.data
            this.getContacts();
            this.checkIn();
          })
          .catch(err => {
            this.errorNotification(`Failed to create customer: ${ err }`)
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        if (!this.stateAmount) {
          return;
        }

        this.checkIn();
      }
    },

    onClickCancel() {
      this.$emit('cancel');
    },

    spacedCardNumber(value) {
      return `XXXX XXXX XXXX ${ value || 'XXXX' }`;
    }
  },
};
</script>

<style lang="scss">
@import '@/style/_variables.scss';

.hold-amount-input {
  .currency-input {
    display: block;
    margin: auto;
    max-width: 180px;
    .bill-field {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
}

.card-label {
  font-size: 14px;
  padding-top: 8px;
  margin-top: 4px;
}

.spinner-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  text-align: center;
  z-index: 9999;
}
</style>
